<template>
    <div class="form-content-wrapper mb-0">
        <b-form-group label="Foto Pendukung">

            <div class="row-3" v-if="dataFotoPendukung.activeFotoPendukungBase64 != null"
                v-for="item of dataFotoPendukung.activeFotoPendukungBase64">
                <b-row no-gutters>
                    <b-col cols="5" class="mx-2">
                        <div class="foto-preview-wrapper my-2">
                            <div class="foto-content-wrapper">
                                <img :src="item" alt="Foto Identitas">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview(item)">View</b-button>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="-1">
                        <b-button class="btn btn-danger btn-sm" @click="removeFoto(item)">X</b-button>
                    </b-col>
                </b-row>
            </div>
            <div class="foto-input-wrapper">

                <div class="foto-action-wrapper">
                    <div class="action-browse-wrapper">
                        <b-form-file v-model="dataFotoPendukung.fotoPendukung" name="fotoPendukung"
                            :state="Boolean(dataFotoPendukung.fotoPendukung)" placeholder="Foto Identitas"
                            drop-placeholder="Drop file here..." accept=".jpg, .png, .jpeg" multiple
                            @input="browseFile($event)"></b-form-file>
                        <b-button variant="cancelBtn">
                            <i class="fa fa-upload mr-2"></i>
                            Upload
                        </b-button>
                    </div>
                    <div class="action-camera-wrapper cameraSmallWrapper">
                        <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto()">
                            <i class="fa fa-camera mr-2"></i>
                            Camera
                        </b-button>
                    </div>
                    <div class="action-reset-wrapper"
                        v-if="dataFotoPendukung.urlFotoPendukung != null && dataFotoPendukung.activeFotoPendukungBase64 != $baseFilePath + dataFotoPendukung.urlFotoPendukung">
                        <b-button variant="cancelBtn" @click="resetFoto()">
                            <i class="fa fa-undo mr-2"></i>
                            Reset
                        </b-button>
                    </div>
                </div>
            </div>
        </b-form-group>
        <ModalWebCam @photoTaken="setResult" />
        <ModalPreview :fotoPreview="activeFotoPreview" />
    </div>
</template>

<script>
import ModalWebCam from '../webcam/ModalWebCam'
import ModalPreview from '../../components/webcam/ModalPreview'

export default {
    name: 'data-foto',
    components: {
        ModalWebCam,
        ModalPreview
    },
    data() {
        return {
            activeFotoPreview: "",
        }
    },
    props: {
        dataFotoPendukung: { type: Object, required: true },
    },
    methods: {

        ambilFoto() {
            this.$bvModal.show("modal-ambil-foto");
        },

        async setResult(result) {
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            if (this.dataFotoPendukung.activeFotoPendukungBase64 == null) {
                this.dataFotoPendukung.activeFotoPendukungBase64 = []
            }
            this.dataFotoPendukung.activeFotoPendukungBase64.push(newResult)
        },

        resetFoto() {
            this.dataFotoPendukung.activeFotoPendukungBase64 = this.$baseFilePath + this.dataFotoPendukung.urlFotoPendukung
        },

        browseFile(files) {
            if (this.dataFotoPendukung.activeFotoPendukungBase64 == null) {
                this.dataFotoPendukung.activeFotoPendukungBase64 = []
            }
            for (var item of files || []) {
                this.toBase64(item).then(async base64 => {
                    if (this.dataFotoPendukung.activeFotoPendukungBase64.includes(await this.$helper.resizeImage(base64))) {
                        return  this.$helper.toastErr(this, "Tidak dapat mengupload foto yang sama!")
                    }
                    this.dataFotoPendukung.activeFotoPendukungBase64.push(await this.$helper.resizeImage(base64))
                })
                    .catch(error => {
                        console.log(error)
                        this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
                    })
            }

            this.clearFotoPendukungInput()

        },

        removeFoto(item){
            this.dataFotoPendukung.activeFotoPendukungBase64 = this.dataFotoPendukung.activeFotoPendukungBase64.filter(file => file != item)
            this.clearFotoPendukungInput()
        },

        clearFotoPendukungInput() {
            this.$nextTick(() => {
                this.dataFotoPendukung.fotoPendukung = null
            })
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        openModalPreview(item) {
            this.activeFotoPreview = item
            this.$bvModal.show("modal-preview-foto")
        }

    }
}
</script>
